import { ReactNode } from "react";
import clsx from "clsx";
// Components
import { TypographyCell } from "@/Layouts/components/Tables/DataSmartTable/additional/TypographyCell";
// Types
import { IconToDisplayProps } from "@/Washouts/types/sales";
// Icons
import RetailIcon from "@/Washouts/assets/icons/retail.svg";
import RetailIconGray from "@/Washouts/assets/icons/retail-gray.svg";
import WholesaleIcon from "@/Washouts/assets/icons/wholesale.svg";
import WholesaleIconGray from "@/Washouts/assets/icons/wholesale-gray.svg";
import FleetIcon from "@/Washouts/assets/icons/fleet.svg";
import FleetIconGray from "@/Washouts/assets/icons/fleet-gray.svg";
import AppendedIcon from "@/Washouts/assets/icons/appended_new.svg";

const DEFAULT_CLASS = "mt-[2px] h-[16px] mx-auto";

function selectIcon(useGray: boolean, iconIfGray: string, iconIfNotGray: string) {
	return useGray ? iconIfGray : iconIfNotGray;
}

export default function IconToDisplay({ params }: Readonly<IconToDisplayProps>) {
	const row = params.row;
	const icon = String(row?.icon ?? "").toLowerCase();
	const useGrayIcon = !row?.isFooter && !row?.subFooter;
	let tooltip = "";
	let innerContent: ReactNode;
	switch (icon) {
		case "fleet":
			tooltip = "Fleet";
			innerContent = (
				<img
					alt="Fleet icon"
					src={selectIcon(useGrayIcon, FleetIconGray, FleetIcon)}
					className={clsx({ [`${DEFAULT_CLASS}`]: true, "text-[#666666]": useGrayIcon })}
				/>
			);
			break;
		case "wholesale":
			tooltip = "Wholesale";
			innerContent = (
				<img
					alt="Wholesale icon"
					src={selectIcon(useGrayIcon, WholesaleIconGray, WholesaleIcon)}
					className={clsx({ [`${DEFAULT_CLASS}`]: true, "text-[#666666]": useGrayIcon })}
				/>
			);
			break;
		case "retail":
			tooltip = "Retail";
			innerContent = (
				<img
					alt="Retail icon"
					src={selectIcon(useGrayIcon, RetailIconGray, RetailIcon)}
					className={clsx({ [`${DEFAULT_CLASS}`]: true, "text-[#666666]": useGrayIcon })}
				/>
			);
			break;
		case "appended":
			tooltip = "Account was added via Appending Configuration.";
			innerContent = <img alt="Appended icon" src={AppendedIcon} className={`${DEFAULT_CLASS} pl-[2px]`} />;
			break;
		default:
			innerContent = <></>;
	}
	if (tooltip !== "") {
		return (
			<TypographyCell
				params={params}
				forceTooltip={true}
				tooltipProps={{
					contentAsTitle: false,
					title: tooltip,
				}}
			>
				{innerContent}
			</TypographyCell>
		);
	} else {
		return <TypographyCell params={params}>{innerContent}</TypographyCell>;
	}
}
